import type { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { Button } from '@seen/ui'
import type { JSX, ReactNode } from 'react'
import { ActivityList } from '#src/components/activity/ActivityList.tsx'
import { useCommentCommunicationActivity } from '#src/components/activity/UseCommentCommunicationActivity.tsx'
import { ScrollAreaContent } from '#src/components/core/scroll-area/ScrollAreaContent.tsx'
import { ScrollAreaHeader } from '#src/components/core/scroll-area/ScrollAreaHeader.tsx'
import { Sheet } from '#src/components/core/sheet/Sheet.tsx'
import { SheetContent } from '#src/components/core/sheet/SheetContent.tsx'
import { SheetTrigger } from '#src/components/core/sheet/SheetTrigger.tsx'

export function EditHistorySheet({
  comment,
  children,
}: {
  comment: CommentCommunication
  children: ReactNode
}): JSX.Element {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="link">{children}</Button>
      </SheetTrigger>
      <SheetContent>
        <ScrollAreaHeader>
          <h5>Activity</h5>
        </ScrollAreaHeader>
        <ScrollAreaContent>
          <EditHistory comment={comment} />
        </ScrollAreaContent>
      </SheetContent>
    </Sheet>
  )
}

function EditHistory({
  comment,
}: {
  comment: CommentCommunication
}): JSX.Element {
  const activity = useCommentCommunicationActivity(comment)
  return <ActivityList>{activity}</ActivityList>
}
